import 'zone.js'; // Included with Angular CLI.

(window as any).global = window;
